import React, { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_URL, clearAuthSession } from '../utils/api';
import { isGuestMode } from '../utils/guestStorage';

const AuthCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('auth_token');

      if (isGuestMode()) {
        navigate('/dashboard', { replace: true });
        return;
      }

      if (!token) {
        navigate('/login', { replace: true });
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const user = response.data?.data;
        localStorage.setItem('user_info', JSON.stringify(user));
        navigate(user?.has_wallet_setup ? '/dashboard' : '/setup-wallet', { replace: true });
      } catch (error) {
        clearAuthSession();
        navigate('/login', { replace: true });
      }
    };

    checkAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f4f7fe]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0056b3] mx-auto mb-4"></div>
        <p className="text-gray-500 font-medium">Memuat aplikasi...</p>
      </div>
    </div>
  );
};

export default AuthCheck;
